import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { IModuleVM } from '../../infrastructure/components/module-vm';
import { Unsubscribe } from 'router5/dist/types/base';
import { IRouter } from '../../infrastructure/router';
import { RouteParams, Routes } from '../../routes-table';
import { RADIX_PARAM } from '../../constants/common.constants';

export enum BlueprintsTab {
    EventBlueprints,
    MeetingTemplates,
    ConnectionTemplates,
    OrderTemplates,
}

export class BlueprintsVM implements IModuleVM {
    @mobx.observable
    private activeTab: BlueprintsTab;
    @mobx.observable

    private subscriptions: Unsubscribe[];

    constructor(@IoC.Inject private readonly routingService: IRouter<RouteParams> = IoC.Container.get(IRouter)) {}

    public didMount(): void {
        this.initRouterSubscriptions();
    }
    public willUnmount(): void {
        this.resetRouterSubscriptions();
    }

    @mobx.action.bound
    public setActiveTab(tab: BlueprintsTab): void {
        this.activeTab = tab;
    }

    public getActiveTab(): BlueprintsTab {
        return this.activeTab;
    }

    public getAccountId(): number {
        return parseInt(this.routeParams.accountId, RADIX_PARAM);
    }

    private get routeParams(): { accountId: string } {
        return this.routingService.router.getState().params;
    }

    @mobx.action.bound
    private initRouterSubscriptions(): void {
        this.subscriptions = [];

        this.subscriptions.push(this.routingService.listen(Routes.EventBlueprintList, () => {
            this.setActiveTab(BlueprintsTab.EventBlueprints);
        }));

        this.subscriptions.push(this.routingService.listen(Routes.MeetingTemplatesList, () => {
            this.setActiveTab(BlueprintsTab.MeetingTemplates);
        }));

        this.subscriptions.push(this.routingService.listen(Routes.ConnectionTemplatesList, () => {
            this.setActiveTab(BlueprintsTab.ConnectionTemplates);
        }));

        this.subscriptions.push(this.routingService.listen(Routes.OrderTemplatesList, () => {
            this.setActiveTab(BlueprintsTab.OrderTemplates);
        }));
    }

    private resetRouterSubscriptions(): void {
        this.subscriptions.forEach(x => x());
        this.subscriptions = [];
    }

}
